import contentRequest from '~/src/api/requests/contentRequest';

export enum EExpand {
    desc = 'description',
    tel = 'telephonyTariff',
    tv = 'domrutvTariff',
    inet = 'internetTariff',
}

/**
 * Получение пакетов продаж
 * @param citydomain - домен
 * @param expand - доп.инфа
 * @param isSale - это распродажа
 * @return promise[]
 */
export const getSalePackages = async(citydomain: string, expand: EExpand[], isSale = true): Promise<object[]> => {
    const resp = await contentRequest.getWithCache(`/${citydomain}/v1/sale-packages`, {
        params: {
            expand: expand.join(','),
            filter: {
                sale: isSale ? 1 : 0,
            },
        }
    });
    return resp.data.items;
};
